import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../const";

export const ADD_KID_PENDING = "ADD_KID_PENDING";
export const ADD_KID_REJECTED = "ADD_KID_REJECTED";
export const ADD_KID_FULFILLED = "ADD_KID_FULFILLED";

const loading = (state = false, { type }) => {
  switch (type) {
    case ADD_KID_PENDING:
      return true;
    case ADD_KID_REJECTED:
    case ADD_KID_FULFILLED:
      return false;
    default:
      return state;
  }
};

const error = (state = null, { type, payload }) => {
  switch (type) {
    case ADD_KID_PENDING:
    case ADD_KID_FULFILLED:
      return null;
    case ADD_KID_REJECTED:
      return payload;
    default:
      return state;
  }
};

const kid = (state = {}, { type, payload }) => {
  switch (type) {
    case ADD_KID_FULFILLED:
      return payload.data;

    default:
      return state;
  }
};

// `auth` reducer
export default combineReducers({ loading, error, kid });

export const createKid = (data, headers) => ({
  type: "ADD_KID",
  payload: axios.post(`${API}api/enfant/creche/enfants`, data, headers)
});
